module.exports = __webpack_public_path__ + "img/spinner.a6fec73c.gif";